import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const BookPurchaseComplete = lazy(() => import('../containers/BookPurchaseComplete'))

const BookPurchaseCompleteApp = (props) => {
  return (
    <AppProvider>
      <Suspense fallback={null}>
        <BookPurchaseComplete books={props.books} coupons={props.coupons} {...props} />
      </Suspense>
    </AppProvider>
  )
}

export default BookPurchaseCompleteApp
